<template>
  <div>
    <Head :title="form.id.toString()"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/financat/barazimet-me-shofere-shperndares">Barazimet me shoferë</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      <Link class="text-indigo-400 font-medium" :href="`/admin/financat/barazimet-me-shofere-shperndares/${barazim.data.id}`">{{ barazim.data.id }}</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      Edito

    </h1>
    <div class=" bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Barazimi (ID)</label>
            <p>{{barazim.data.id}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Shoferi</label>
            <p>{{barazim.data.driver}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Data e regjistrimit</label>
            <p>{{ barazim.data.hr_created_at }}</p>
          </div>

          <file-output v-if="form.document_path" v-model="form.document_path" :error="form.errors.document_path" class="pb-8 pr-6 w-full lg:w-1/4"  label="Dëshmia e barazimit" />
          <file-input v-else v-model="form.barazim_document" :error="form.errors.barazim_document" class="pb-8 pr-6 w-full lg:w-1/4" type="file" accept="image/*" label="Dëshmia e barazimit" />

        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-2 pr-4 w-full lg:w-1/6">
            <label class="form-label text-sm ">Ndrysho datën:</label>
            <input id="created_at" v-model="form.created_at" type="datetime-local" class="form-select focus:ring-0 hover:border-indigo-500">
          </div>


          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Paratë e dorëzuara nga shoferi</h3>
          <number-input v-for="banknote in form.banknotes" v-model="banknote.pivot.total" :error="form.errors[`banknotes.${banknote.id}.total`]" class="pb-2 pr-4 w-full lg:w-1/6"
                        :label="`${banknote.value}(${banknote.name})`"
          />

          <number-input disabled v-model="form.delivered_amount" :error="form.errors.delivered_amount" class="pb-8 pr-6 w-full lg:w-1/6"
                        label="Shuma totale"
          />

        </div>
        <hr>
        <div class="flex flex-wrap -mb-4 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Shpenzimet</h3>

          <text-input v-model="form.petrol_expenses_amount" :error="form.errors.petrol_expenses_amount" class="pb-8 pr-6 w-full lg:w-1/6"
                      label="Shpenzimet për naftë"
          />

          <text-input v-model="form.personal_expenses_amount" :error="form.errors.personal_expenses_amount" class="pb-8 pr-6 w-full lg:w-1/6"
                      label="Shpenzime personale"
          />

          <text-input v-model="form.other_expenses_amount" :error="form.errors.other_expenses_amount" class="pb-8 pr-6 w-full lg:w-1/6"
                      label="Shpenzime tjera"
          />

          <textarea-input v-model="form.additional_info" :error="form.errors.additional_info" class="pb-8 pr-6 w-full lg:w-full" label="Informata shtesë" />

        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8  w-full lg:w-1/2">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full"><input type="checkbox" class="mr-3" v-model="showAdditionalPackages" @click="toggleAdditionalPackages(!showAdditionalPackages)">Pako shtesë</h3>

          <div v-if="showAdditionalPackages" v-for="(additionalPackage, index) in form.additional_packages" class="flex flex-wrap">
            <text-input  class="pb-4 pr-6 w-full lg:w-1/3" v-model="additionalPackage.order_id" :error="form.errors[`additional_packages.${index}.order_id`]"
                         label="Dërgesa"/>

            <text-input class="pb-4 pr-6 w-full lg:w-1/3" v-model="additionalPackage.packages" :error="form.errors[`additional_packages.${index}.packages`]"
                        label="Numri i pakove"/>

            <div class="flex flex-wrap lg:flex-nowrap mb-6 mt-6 items-center justify-between">
              <button class="ml-auto" type="button"><icon name="create" class="flex-shrink-0 mr-2 w-5 h-5 fill-green-600" @click="addPackage"/></button>
              <button class="ml-auto" type="button"><icon name="trash" class="flex-shrink-0 ml-2 w-5 h-5 fill-red-600" @click="removePackage(index)"/></button>
            </div>
          </div>

        </div>


        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.role === 'superadmin' && !barazim.data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Fshij</button>
          <loading-button  :loading="form.processing" class="btn-indigo ml-auto" type="button" @click="update">Edito</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import {computed} from 'vue'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'
import NumberInput from '@/Shared/NumberInput'
import FileOutput from '@/Shared/FileOutput'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    Modal,
    FileInput,
    NumberInput,
    FileOutput,
    Icon
  },
  layout: Layout,
  props: {
    barazim: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        id: this.barazim.data.id,
        delivery_driver_id: this.barazim.data.driver_id,
        delivered_amount: this.barazim.data.delivered_amount,
        petrol_expenses_amount: this.barazim.data.petrol_expenses_amount,
        personal_expenses_amount: this.barazim.data.personal_expenses_amount,
        other_expenses_amount: this.barazim.data.other_expenses_amount,
        additional_info: this.barazim.data.additional_info,
        banknotes: this.barazim.data.banknotes,
        document_path: this.barazim.data.document_path,
        barazim_document: null,
        created_at: null,
        additional_packages: this.barazim.data.additional_packages
      }),
      showAdditionalPackages: this.barazim.data.additional_packages.length > 0,
    }
  },
  methods: {
    update() {
      this.form.post(`/admin/financat/barazimet-me-shofere-shperndares/${this.barazim.data.id}`)
    },
    destroy() {
      if (confirm('Të gjitha dërgesat që i takojnë këtij barazimi do të bëhen të PABARAZUARA. A jeni të sigurt se dëshironi të vazhdoni?')) {
        this.$inertia.delete(`/admin/financat/barazimet-me-shofere-shperndares/${this.barazim.data.id}`)
      }
    },
    formatDate(createdAt){
      let date = new Date(createdAt)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US',{hour12: false})
    },
    addPackage(){
      this.form.additional_packages.push({ order_id : null, packages: null})
    },
    removePackage(index){
      if(this.form.additional_packages.length > 1){
        this.form.additional_packages.splice(index,1)
        this.form.errors = []
      }
    },
    toggleAdditionalPackages(show){
      if(show){
        this.showAdditionalPackages = true
        this.addPackage()
      }else {
        this.showAdditionalPackages = false
        this.form.additional_packages = []
      }
    },
  },
  watch: {
    'form.banknotes': {
      deep: true,
      handler() {
        let totalAmount = 0
        this.form.banknotes.forEach((banknote) => {
          totalAmount += (banknote.value * banknote.pivot.total)
        })
        this.form.delivered_amount = parseFloat(totalAmount).toFixed(2)
      }
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
